module.exports = __webpack_public_path__ + "img/P150T_weapon_69.d0255110.png";